import React, { createContext, useContext, useState } from 'react'
import Honeybadger from 'honeybadger-js'

const { apiKey, ...baseConfig } = window.__APP_CONFIG__.honeybadger || {}

const createHoneybadger = () =>
  Honeybadger.configure({
    ...baseConfig,
    api_key: apiKey,
  })

const HoneybadgerContext = createContext(createHoneybadger())

export const useHoneybadger = () => useContext(HoneybadgerContext)

export function HoneybadgerProvider({ children }) {
  const [honeybadger] = useState(createHoneybadger())

  return (
    <HoneybadgerContext.Provider value={honeybadger}>
      {children}
    </HoneybadgerContext.Provider>
  )
}
